/**
 * @author Muhammad Fahad
 * @datetime April, 1st 2022
 * @description: This is dashboard class/component. This component is main for
 *                user dashboard. All the other sub-component of dashboard will
 *                be part of this component
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CognitoUtil } from '../shared/utils/cognito.service';
import { Router } from '@angular/router';
import { StateManagementService } from '../shared/services/state-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { UserCards } from '../shared-layout/Components/activity/user-card.interface';
import { CONSTANTS } from '../shared/constants/constants';
import { DashboardManagementService } from './dashboard-management.service';
import { IAppState } from '../shared/state-management/state-interfaces';
import { NgRedux } from '@angular-redux/store';
import { Subject, Subscription } from 'rxjs';
import { SharedDataService } from '../shared/services/shared-data.service';
import { CommonService } from '../shared/utils/common.service';
import { takeUntil } from 'rxjs/operators';
import { LocalizationService } from '../shared/services/localization.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  dashboardList!: UserCards;
  sharedData!: any;
  siteId!: string;
  dashboardSubscription: Subscription | undefined;
  subscription: Subscription | undefined;
  commonAccessControl!: boolean;

  /**
   * @description constructor to inject dependencies
   * @param { Router } route
   * @param { CognitoUtil } cognitoUtil
   * @param { StateManagementService } stateManagementService
   */
  constructor(
    private route: Router,
    public cognitoUtil: CognitoUtil,
    private stateManagementService: StateManagementService,
    private dashboardManagementService: DashboardManagementService,
    private ngRedux: NgRedux<IAppState>,
    private sharedDataService: SharedDataService,
    private commonService: CommonService,
    private localizationService: LocalizationService
  ) {
    this.subscription = this.ngRedux
      .select('dashboardActivities')
      .subscribe((dashboardActivity: any) => {
        if (
          JSON.stringify(this.dashboardList) !==
          JSON.stringify(dashboardActivity)
        ) {
          this.dashboardList = dashboardActivity;
        }
      });
  }

  /**
   * @description: default load function of angular
   * @input {none}
   * @output {void}
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.dashboardSubscription =
      this.commonService.getDashboardStatisticsSubject.subscribe(
        (siteId: string) => {
          if (siteId) {
            this.getDashboardStatistics(siteId);
            this.commonService.setDashboardStatistics('');
          }
        }
      );

    this.sharedDataService.currentData.subscribe((sharedData: any) => {
      this.sharedData = sharedData;
      if (
        this.sharedData.selectedSite.siteId &&
        this.siteId != this.sharedData.selectedSite.siteId
      ) {
        this.siteId = this.sharedData.selectedSite.siteId;
        this.commonAccessControl = this.sharedData.selectedSite.commonAccessControl;
        this.getDashboardStatistics(this.sharedData.selectedSite.siteId);
      }
    });
    this.stateManagementService.updateShowHeader(true);
  }
  /**
   * @description get dashobard statistic
   * @param siteId
   * @returns void
   */
  getDashboardStatistics(siteId: string): void {
    this.dashboardManagementService.getDashboardStatistics(siteId).subscribe();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
